import { useState } from 'react';
import { apiUrl } from '../lib/api.js';

/**
 * Contact avatar. Renders the cached/same-origin profile image when present; on
 * a load failure (or no image) it falls back to an initials chip rather than a
 * broken-image icon. A leading-slash src (e.g. `/contacts/avatar/:id`) is
 * resolved against the API base. Shared by the thread + contact cards.
 */
export function ProfilePhoto({
  src,
  label,
  className = 'unified-profile-photo',
}: {
  src: string | null;
  label: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div className={`${className} unified-profile-photo-fallback`} aria-hidden="true">
        {initialsOf(label)}
      </div>
    );
  }
  return (
    <img
      src={apiUrl(src)}
      alt=""
      className={className}
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  );
}

export function initialsOf(label: string): string {
  const parts = label
    .trim()
    .split(/\s+/)
    .filter((w) => /[a-z0-9]/i.test(w));
  if (parts.length === 0) return '·';
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}
